import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getPathLanguage } from '../../../utils/params';

const BreadcrumbNormalPage = () => {
  const { t } = useTranslation();
  const pathLanguage = getPathLanguage(useLocation());

  return (
    <div className="section-block background-gray p-0">
      <div className="container">
        <div className="row breadcrumb align-items-center">
          <div className="col-6">
            <div className="breadcrumb-item row">
              <ul>
                <li className="first">
                  <Link className="home" to={pathLanguage}>
                    {t('normal.home')}
                  </Link>
                </li>
                <li className="item">
                  &#8226;&nbsp;<span className="active"> {t('normal.usefull_information')}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadcrumbNormalPage;
